import React, { useState, useEffect } from 'react';

const UtilityBar = ({ t, lang, setLang, setPage }) => {
  const isEn = lang === 'en';
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY < 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`hidden lg:flex w-full bg-navy text-white/90 text-[13px] fixed top-0 left-0 right-0 z-[60] transition-transform duration-300 ${
        visible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-[1440px] w-full mx-auto px-5 lg:px-8 xl:px-[120px] h-12 box-border flex items-center justify-end gap-6 sm:gap-7">
        {/* Career */}
        <button
          type="button"
          onClick={() => {
            if (setPage) setPage('coming-soon');
          }}
          className="hover:text-gold transition-colors duration-200 font-medium cursor-pointer bg-transparent border-0 text-white/90 p-0 text-[13px]"
        >
          {t?.career || (isEn ? 'Career' : 'Karir')}
        </button>

        {/* Divider */}
        <div className="h-4 w-px bg-white/20" />

        {/* Parent & Student Portal */}
        <button
          type="button"
          onClick={() => {
            if (setPage) setPage('coming-soon');
          }}
          className="hover:text-gold transition-colors duration-200 font-medium cursor-pointer bg-transparent border-0 text-white/90 p-0 text-[13px]"
        >
          {t?.parentStudentPortal || (isEn ? 'Parent & Student Portal' : 'Portal Orang Tua & Siswa')}
        </button>

        {/* Divider */}
        <div className="h-4 w-px bg-white/20" />

        {/* Language Switcher (Inline Switcher, not dropdown) */}
        <div
          className="inline-flex items-center bg-white/10 rounded-[4px] p-0.5 border border-white/15"
          role="group"
          aria-label="Language Switcher"
        >
          <button
            type="button"
            onClick={() => setLang && setLang('en')}
            aria-label="English"
            aria-pressed={isEn}
            className={`px-2.5 py-1 rounded-[3px] text-[12px] font-bold tracking-wider transition-all duration-200 border-0 cursor-pointer ${
              isEn
                ? 'bg-gold text-navy shadow-sm'
                : 'bg-transparent text-white/70 hover:text-white'
            }`}
          >
            EN
          </button>
          <button
            type="button"
            onClick={() => setLang && setLang('id')}
            aria-label="Bahasa Indonesia"
            aria-pressed={!isEn}
            className={`px-2.5 py-1 rounded-[3px] text-[12px] font-bold tracking-wider transition-all duration-200 border-0 cursor-pointer ${
              !isEn
                ? 'bg-gold text-navy shadow-sm'
                : 'bg-transparent text-white/70 hover:text-white'
            }`}
          >
            ID
          </button>
        </div>
      </div>
    </div>
  );
};

export default UtilityBar;
